module.exports = __webpack_public_path__ + "media/images/countrysquared/eg-3ded77761861ec712bdc18db9dbfcc83.svg";